export enum LevelSelectionEvent {
  LEVEL_CONFIRMED = 'level_selection_level_confirmed',
  TAKE_PLACEMENT_TEST = 'level_selection_take_placement_test',
  CLOSE_LEVEL_SELECTION = 'level_selection_close',
}


// WEBPACK FOOTER //
// ./ts/app/home/level-selection/level-selection-event.ts